module.exports = __webpack_public_path__ + "static/media/thank-you-page-bottom.04febaa9.svg";